<ion-item lines="none" class="ion-no-padding">
  <ion-label *ngIf="!hideLabel" position="stacked">{{ label + (required ? '*' : '')  }}</ion-label>
  <ion-input type="tel" [id]="id" [maxlength]="maxLength" placeholder="(___) ___-____" #phoneInput
  [disabled]="disabled" (ionChange)="maskInput($event)" (ionBlur)="checkValidity()" [inputFocus]="focus"></ion-input>
</ion-item>